module.exports = __webpack_public_path__ + "img/portfolio-02.5dee8713.b395e5df.jpg";